import { useLocation } from 'react-router-dom';

import useAuth from '@/hooks/use-auth';
import { APP_ROUTES } from '@/lib/routes/app-routes';
import { USER_ROLES } from '@/utils/constants/roles';

type UseRoleAccessParams = {
  isRoleSwitching?: boolean;
  pendingRole?: string;
};

const useRoleAccess = ({ isRoleSwitching = false, pendingRole }: UseRoleAccessParams = {}) => {
  const { userRoles, activeRole, selectedPermissionRole } = useAuth();
  const { pathname } = useLocation();

  const isDashboard = pathname === APP_ROUTES.dashboard;
  const isArchive = pathname === APP_ROUTES.archive;

  const isOps = userRoles.includes(USER_ROLES.ops);
  const isQs = userRoles.includes(USER_ROLES.qs);
  const isAd = userRoles.includes(USER_ROLES.ad);
  const isAdAndQs = isAd && isQs;
  const isOpsAndQs = isOps && isQs && !isAd;
  const isQsActive = activeRole === USER_ROLES.qs;
  const isAdActive = activeRole === USER_ROLES.ad;

  const showBottomNav = isOpsAndQs || isAdAndQs;
  const showRoleSwitcher = isOps && !isQsActive && !isAdActive;

  const isTabSwitching = isRoleSwitching && pendingRole === USER_ROLES.qs;

  const isValidRoute = (isDashboard && !isQsActive) || (isArchive && isQsActive);

  const isAdOnArchive = isAd && !isAdAndQs && isArchive;

  const shouldRedirect = (!isAd && !isValidRoute) || isAdOnArchive || (isAdAndQs && !isValidRoute);

  const isBottomNavVisible = showBottomNav && !isRoleSwitching && !shouldRedirect;

  const showLoader = isRoleSwitching || shouldRedirect;

  return {
    isOps,
    isQs,
    isAd,
    isAdAndQs,
    isOpsAndQs,
    isQsActive,
    isAdActive,
    selectedPermissionRole,
    showRoleSwitcher,
    showBottomNav,
    isTabSwitching,
    shouldRedirect,
    isBottomNavVisible,
    showLoader,
  };
};

export default useRoleAccess;
